import master2026 from './calendarOccasions2026';
import historicalOccasions2026 from './historicalOccasions2026';
import sikhOccasions2026 from './sikhOccasions2026';

const essentialGlobalObservances = new Set([
  'World Hindi Day', 'International Day of Education', 'World Cancer Day',
  'International Mother Language Day', "International Women's Day", 'World Water Day',
  'World Health Day', 'Earth Day', 'World Book and Copyright Day', 'World Press Freedom Day',
  'International Day of Families', 'World Environment Day', 'International Day of Yoga',
  'International Youth Day', 'International Literacy Day', 'International Day of Peace',
  'World Tourism Day', 'World Mental Health Day', 'World Food Day', "World Children's Day",
  'World AIDS Day', 'International Day of Persons with Disabilities', 'Human Rights Day',
  "International Workers' Day / May Day", 'International Nurses Day', 'World Blood Donor Day', 'World Heart Day'
]);

function keepGlobalObservance([, name, category]) {
  // Indian national days that merely share a date with a UN day (e.g. Gandhi Jayanti) stay.
  if (/^national\b/i.test(category)) return true;
  const isGlobal = /international|world|global|united nations/i.test(`${name} ${category}`);
  return !isGlobal || essentialGlobalObservances.has(name);
}

function isReplacedSikhRow([, name, category]) {
  return /sikh/i.test(category) || /guru|gurpurab|shaheedi|bandi chhor|hola mohalla|khalsa sajna|mela maghi/i.test(name);
}

const expanded2026Names = {
  '02-21|International Mother Language Day': 'International Mother Language Day / Bangla Language Movement Remembrance',
  '03-22|Bihar Diwas': 'Bihar Diwas',
  '03-30|Rajasthan Day': 'Rajasthan Day',
  '04-13|Jallianwala Bagh Remembrance': 'Jallianwala Bagh Massacre Remembrance',
  '06-29|National Statistics Day': 'P. C. Mahalanobis Birth Anniversary / National Statistics Day',
  "07-01|National Doctors' Day": "Dr. Bidhan Chandra Roy Birth and Death Anniversary / National Doctors' Day",
  '08-06|Hiroshima Day': 'Hiroshima Remembrance Day',
  '08-14|Partition Horrors Remembrance Day': 'Partition Horrors Remembrance Day',
  '08-20|Sadbhavana Diwas': 'Rajiv Gandhi Birth Anniversary / Sadbhavana Diwas',
  '08-29|National Sports Day / Major Dhyan Chand Jayanti': 'Major Dhyan Chand Birth Anniversary / National Sports Day',
  "09-05|Teachers' Day (India)": "Dr. Sarvepalli Radhakrishnan Birth Anniversary / Teachers' Day",
  '09-14|Hindi Diwas': 'Hindi Diwas / Constituent Assembly Official-Language Decision Anniversary',
  "09-15|Engineers' Day (India)": "M. Visvesvaraya Birth Anniversary / Engineers' Day",
  '11-01|Kerala Piravi': 'Kerala Piravi / Kerala Formation Day',
  '11-24|Guru Tegh Bahadur Ji Shaheedi Diwas': "Guru Tegh Bahadur Ji's 350th Shaheedi Year Commemoration",
  '11-26|Constitution Day / Samvidhan Divas': 'Constitution Adoption Anniversary / Constitution Day',
  '12-02|Assam Divas / Sukapha Divas': 'Sukapha Divas / Assam Divas',
  '12-16|Vijay Diwas': 'Vijay Diwas / 1971 War Anniversary',
  '12-19|Goa Liberation Day': 'Goa Liberation Day',
  '12-22|National Mathematics Day / Srinivasa Ramanujan Jayanti': 'Srinivasa Ramanujan Birth Anniversary / National Mathematics Day',
  "12-23|Kisan Diwas / National Farmers' Day": 'Chaudhary Charan Singh Birth Anniversary / Kisan Diwas',
  '12-25|Good Governance Day / Atal Bihari Vajpayee Jayanti': 'Atal Bihari Vajpayee Birth Anniversary / Good Governance Day',
  '12-26|Veer Bal Diwas': 'Veer Bal Diwas / Sahibzade Remembrance'
};
const expandedNames = new Set(Object.values(expanded2026Names));

export const occasionSources = {
  india: 'https://cag.gov.in/uploads/media/List-of-Gazetted-Holidays-and-Restricted-Holidays-2026-069492ddf80fa39-36385303.pdf',
  international: 'https://www.un.org/en/observances/list-days-weeks'
};

export const indianStates = [
  'Andaman and Nicobar Islands', 'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar',
  'Chandigarh', 'Chhattisgarh', 'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Goa',
  'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jammu and Kashmir', 'Jharkhand', 'Karnataka',
  'Kerala', 'Ladakh', 'Lakshadweep', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya',
  'Mizoram', 'Nagaland', 'Odisha', 'Puducherry', 'Punjab', 'Rajasthan', 'Sikkim',
  'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal'
];

// Lunar dates are intentionally year-scoped. They must not silently repeat in another year.
const festivals2026 = [
  ['01-13', 'Lohri'], ['01-14', 'Makar Sankranti / Pongal / Magh Bihu'],
  ['01-23', 'Basant Panchami'], ['02-01', 'Guru Ravidas Jayanti'], ['02-15', 'Maha Shivratri'],
  ['03-03', 'Holika Dahan / Dolyatra'], ['03-04', 'Holi / Hola Mohalla'],
  ['03-19', 'Ugadi / Gudi Padwa / Cheti Chand'], ['03-21', 'Eid-ul-Fitr'],
  ['03-27', 'Ram Navami'], ['03-31', 'Mahavir Jayanti'], ['04-02', 'Hanuman Jayanti'],
  ['04-03', 'Good Friday'], ['04-05', 'Easter'], ['04-14', 'Vaisakhi / Vishu / Tamil New Year'],
  ['04-15', 'Bengali New Year / Bohag Bihu'], ['04-19', 'Akshaya Tritiya'],
  ['05-01', 'Buddha Purnima'], ['05-27', 'Eid-ul-Adha'], ['06-26', 'Muharram'],
  ['07-16', 'Ratha Yatra'], ['08-15', 'Parsi New Year'], ['08-26', 'Onam'],
  ['08-26', 'Milad-un-Nabi'], ['08-28', 'Raksha Bandhan'], ['09-04', 'Janmashtami'],
  ['09-14', 'Ganesh Chaturthi'], ['10-12', 'Navratri begins'], ['10-19', 'Maha Navami / Durga Puja'],
  ['10-20', 'Dussehra / Vijayadashami'], ['10-26', 'Valmiki Jayanti'], ['10-29', 'Karwa Chauth'],
  ['11-06', 'Dhanteras'], ['11-08', 'Diwali / Naraka Chaturdashi / Bandi Chhor Divas'],
  ['11-09', 'Govardhan Puja'], ['11-11', 'Bhai Dooj'], ['11-15', 'Chhath Puja'],
  ['11-24', 'Guru Nanak Gurpurab'], ['11-24', "Guru Tegh Bahadur's Martyrdom Day"]
];

const national = [
  ['01-01', "New Year's Day"], ['01-12', 'National Youth Day'], ['01-15', 'Indian Army Day'],
  ['01-23', 'Parakram Diwas'], ['01-24', 'National Girl Child Day'], ['01-25', 'National Voters Day'],
  ['01-26', 'Republic Day'], ['01-30', "Martyrs' Day"], ['02-28', 'National Science Day'],
  ['04-11', 'National Safe Motherhood Day'], ['05-11', 'National Technology Day'],
  ['07-01', "National Doctors' Day"], ['08-15', 'Independence Day'], ['08-29', 'National Sports Day'],
  ['09-05', "Teachers' Day (India)"], ['09-14', 'Hindi Diwas'], ['09-15', "Engineers' Day (India)"],
  ['10-02', 'Gandhi Jayanti'], ['10-31', 'National Unity Day'], ['11-11', 'National Education Day'],
  ['11-14', "Children's Day (India)"], ['11-26', 'Constitution Day'], ['12-04', 'Indian Navy Day'],
  ['12-23', 'National Farmers Day'], ['12-24', 'Christmas Eve'], ['12-25', 'Christmas']
];

const international = [
  ['01-04', 'World Braille Day'], ['01-24', 'International Day of Education'],
  ['02-02', 'World Wetlands Day'], ['02-11', 'International Day of Women and Girls in Science'],
  ['02-20', 'World Day of Social Justice'], ['02-21', 'International Mother Language Day'],
  ['03-08', "International Women's Day"], ['03-20', 'International Day of Happiness'],
  ['03-21', 'International Day of Forests'], ['03-22', 'World Water Day'], ['04-07', 'World Health Day'],
  ['04-22', 'International Mother Earth Day'], ['04-23', 'World Book and Copyright Day'],
  ['05-03', 'World Press Freedom Day'], ['05-15', 'International Day of Families'],
  ['05-21', 'International Tea Day'], ['05-31', 'World No Tobacco Day'], ['06-05', 'World Environment Day'],
  ['06-08', 'World Oceans Day'], ['06-21', 'International Day of Yoga'], ['07-11', 'World Population Day'],
  ['07-30', 'International Day of Friendship'], ['08-12', 'International Youth Day'],
  ['09-05', 'International Day of Charity'], ['09-08', 'International Literacy Day'],
  ['09-15', 'International Day of Democracy'], ['09-16', 'World Ozone Day'],
  ['09-21', 'International Day of Peace'], ['09-27', 'World Tourism Day'],
  ['10-01', 'International Day of Older Persons'], ['10-05', "World Teachers' Day"],
  ['10-10', 'World Mental Health Day'], ['10-16', 'World Food Day'], ['10-24', 'United Nations Day'],
  ['11-14', 'World Diabetes Day'], ['11-20', "World Children's Day"], ['12-01', 'World AIDS Day'],
  ['12-03', 'International Day of Persons with Disabilities'], ['12-10', 'Human Rights Day']
];

const regional2026 = {
  Punjab: [
    ['01-13', 'Lohri'], ['01-14', 'Maghi'], ['02-01', 'Guru Ravidas Jayanti'],
    ['03-04', 'Hola Mohalla'], ['04-14', 'Vaisakhi'], ['06-16', 'Guru Arjan Dev Martyrdom Day'],
    ['11-08', 'Bandi Chhor Divas'], ['11-24', 'Guru Nanak Gurpurab'],
    ['11-24', "Guru Tegh Bahadur's Martyrdom Day"]
  ],
  Chandigarh: [['01-13', 'Lohri'], ['03-04', 'Hola Mohalla'], ['04-14', 'Vaisakhi'], ['11-24', 'Guru Nanak Gurpurab']],
  Haryana: [['01-13', 'Lohri'], ['04-14', 'Vaisakhi'], ['11-24', 'Guru Nanak Gurpurab']],
  'Himachal Pradesh': [['01-13', 'Lohri'], ['04-14', 'Vaisakhi'], ['06-16', 'Guru Arjan Dev Martyrdom Day']],
  Assam: [['01-14', 'Magh Bihu'], ['04-15', 'Bohag Bihu']],
  Bihar: [['11-15', 'Chhath Puja']],
  Gujarat: [['10-12', 'Navratri begins'], ['10-20', 'Vijayadashami']],
  Karnataka: [['03-19', 'Ugadi'], ['11-01', 'Karnataka Rajyotsava']],
  Kerala: [['04-14', 'Vishu'], ['08-26', 'Onam']],
  Maharashtra: [['03-19', 'Gudi Padwa'], ['09-14', 'Ganesh Chaturthi']],
  Odisha: [['07-16', 'Ratha Yatra']],
  'Tamil Nadu': [['01-14', 'Pongal'], ['04-14', 'Tamil New Year']],
  Telangana: [['03-19', 'Ugadi'], ['10-12', 'Bathukamma season']],
  'Andhra Pradesh': [['03-19', 'Ugadi']],
  'West Bengal': [['04-15', 'Poila Boishakh'], ['10-19', 'Durga Puja'], ['10-20', 'Vijayadashami']]
};

function normalizedState(state) {
  const value = String(state || '').trim().toLowerCase();
  return indianStates.find((item) => item.toLowerCase() === value) || '';
}

function uniqueRows(rows) {
  const seen = new Set();
  return rows.filter((row) => {
    const key = `${row.date}-${row.name}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

function appliesToState(audience, state) {
  if (!state || /all india/i.test(audience)) return true;
  const regions = String(audience || '').toLowerCase();
  const mentionedStates = indianStates.filter((item) => regions.includes(item.toLowerCase()));
  if (state === 'Uttar Pradesh' && /\bup\b/i.test(audience)) return true;
  return !mentionedStates.length || mentionedStates.includes(state);
}

export function occasionsForYear(year, options = {}) {
  const state = normalizedState(options.state);
  if (year === 2026) {
    const master = [...master2026.filter((row) => keepGlobalObservance(row) && !isReplacedSikhRow(row)), ...sikhOccasions2026]
      .filter(([, , , audience]) => appliesToState(audience, state))
      .map(([date, originalName, category, audience, dateNote, priority, source]) => ({
        date, name: expanded2026Names[`${date.slice(5)}|${originalName}`] || originalName,
        category, audience, dateNote, priority, source,
        id: `${date}-${originalName}`
      }));
    const history = historicalOccasions2026
      .filter(([, name, audience = 'All India']) => !expandedNames.has(name) && appliesToState(audience, state))
      .map(([day, name, audience = 'All India', dateNote = '']) => ({
        date: `2026-${day}`, name, category: 'Indian history', audience, dateNote,
        priority: 'HIGH', source: '', id: `2026-${day}-${name}`
      }));
    return uniqueRows([...master, ...history]).sort((a, b) => a.date.localeCompare(b.date) || a.name.localeCompare(b.name));
  }
  const rows = [
    ...national.map(([date, name]) => ({ date, name, category: 'India' })),
    ...international.map(([date, name]) => ({ date, name, category: 'International' })),
    ...(year === 2026 ? festivals2026.map(([date, name]) => ({ date, name, category: 'Festival' })) : []),
    ...(year === 2026 && state ? (regional2026[state] || []).map(([date, name]) => ({ date, name, category: state })) : [])
  ];
  return uniqueRows(rows).map((row) => ({
    ...row,
    date: `${year}-${row.date}`,
    id: `${year}-${row.date}-${row.name}`,
    source: row.category === 'International' ? occasionSources.international : occasionSources.india
  })).sort((a, b) => a.date.localeCompare(b.date) || a.name.localeCompare(b.name));
}

export function upcomingOccasionDays(today, count = 7, options = {}) {
  const year = Number(today.slice(0, 4));
  const days = new Map();
  [...occasionsForYear(year, options), ...occasionsForYear(year + 1, options)]
    .filter((event) => event.date >= today)
    .forEach((event) => {
      if (!days.has(event.date)) days.set(event.date, []);
      days.get(event.date).push(event);
    });
  return [...days].slice(0, count).map(([date, events]) => ({ date, events }));
}

export function occasionThemeWindow(today, state, leadDays = 2) {
  const start = new Date(`${today}T00:00:00+05:30`);
  const end = new Date(start);
  end.setDate(end.getDate() + leadDays);
  const endKey = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).format(end);
  const events = upcomingOccasionDays(today, 4, { state }).filter((day) => day.date <= endKey);
  return events.length ? events[0] : null;
}

export function indiaToday(now = new Date()) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
}
